import React from 'react';
import { Menu, MenuType, MenuChoice as MenuChoiceType } from '../../services/api';

interface MenuChoiceProps {
  menu_choice: MenuChoiceType;
  menu: Menu | undefined;
  index: number;
  t: (key: string) => string;
  handleMenuChoiceChange: (index: number, field: keyof MenuChoiceType, value: string) => void;
}

const MenuChoice: React.FC<MenuChoiceProps> = ({
  menu_choice,
  menu,
  index,
  t,
  handleMenuChoiceChange,
}) => (
  <>
    <div className="guest-row-single">
      <div className="guest-input-group">
        <label>{t('menuType')}</label>
        <select
          value={menu_choice.type}
          onChange={e => handleMenuChoiceChange(index, 'type', e.target.value)}
        >
          <option value={MenuType.Adult}>{t('adult')}</option>
          <option value={MenuType.Child}>{t('child')}</option>
          <option value={MenuType.Baby}>{t('baby')}</option>
        </select>
      </div>
    </div>
    {menu_choice.type === MenuType.Adult && (
      <>
        <div className="guest-row-single">
          <div className="guest-input-group">
            <label>{t('starter')}</label>
            <select
              value={menu_choice.starter}
              onChange={e => handleMenuChoiceChange(index, 'starter', e.target.value)}
              required
            >
              <option value="" disabled>
                {t('pleaseSelect')}
              </option>
              {menu?.starters?.map(item => (
                <option key={item.id} value={item.id}>
                  {item.description}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="guest-row-single">
          <div className="guest-input-group">
            <label>{t('main')}</label>
            <select
              value={menu_choice.main}
              onChange={e => handleMenuChoiceChange(index, 'main', e.target.value)}
              required
            >
              <option value="" disabled>
                {t('pleaseSelect')}
              </option>
              {menu?.mains?.map(item => (
                <option key={item.id} value={item.id}>
                  {item.description}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="guest-row-single">
          <div className="guest-input-group">
            <label>{t('dessert')}</label>
            <select
              value={menu_choice.dessert}
              onChange={e => handleMenuChoiceChange(index, 'dessert', e.target.value)}
              required
            >
              <option value="" disabled>
                {t('pleaseSelect')}
              </option>
              {menu?.desserts?.map(item => (
                <option key={item.id} value={item.id}>
                  {item.description}
                </option>
              ))}
            </select>
          </div>
        </div>
      </>
    )}
    <div className="guest-row-single">
      <div className="guest-input-group">
        <label>{t('dietaryRestrictions')}</label>
        <input
          type="text"
          value={menu_choice.restrictions || ''}
          onChange={e => handleMenuChoiceChange(index, 'restrictions', e.target.value)}
          placeholder={t('dietaryRestrictionsPlaceholder')}
        />
      </div>
    </div>
  </>
);

export default MenuChoice;
